export default [
  {
    name: "login",
    path: "/login?next",
  },
];
